import { create } from 'zustand';
/** online = number of open tabs connected to /ws/presence (server-counted). null = unknown; never invented. */
export const usePresence = create<{ online: number | null; state: 'connecting' | 'open' | 'closed' }>(() => ({ online: null, state: 'connecting' }));
let attempt = 0;
export function connectPresence() {
  const ws = new WebSocket(`${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws/presence`);
  let ping: number | null = null;
  ws.onopen = () => { attempt = 0; usePresence.setState({ state: 'open' }); ping = window.setInterval(() => ws.readyState === 1 && ws.send('ping'), 20000); };
  ws.onmessage = (e) => { try { const m = JSON.parse(String(e.data)); if (m.t === 'presence' && Number.isInteger(m.online)) usePresence.setState({ online: m.online }); } catch { /* */ } };
  ws.onclose = () => {
    if (ping) clearInterval(ping);
    usePresence.setState({ online: null, state: 'closed' });
    const delay = Math.min(30000, 1000 * 2 ** attempt++) * (0.75 + Math.random() * 0.5);
    setTimeout(connectPresence, delay);
  };
}
